export default __webpack_public_path__ + "static/media/red-tick.83cc9b54.svg";